import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SeoContent from '../components/SeoContent';
import PageSEO from '../components/PageSEO';

const FAMOUS = [
  { text: 'racecar', label: 'Racecar' },
  { text: 'level',   label: 'Level'   },
  { text: 'civic',   label: 'Civic'   },
  { text: 'madam',   label: 'Madam'   },
  { text: 'A man a plan a canal Panama', label: 'Famous phrase' },
  { text: 'Was it a car or a cat I saw', label: 'Classic' },
  { text: 'Never odd or even', label: 'Fun one' },
];

function isPalindrome(text) {
  const clean = text.toLowerCase().replace(/[^a-z0-9]/g,'');
  return clean === clean.split('').reverse().join('');
}

export default function PalindromeChecker() {
  const [input, setInput]   = useState('');
  const [checked, setChecked] = useState(false);

  function handleCheck(e) {
    e.preventDefault();
    if (input.trim()) setChecked(true);
  }

  const result = checked && input.trim() ? isPalindrome(input) : null;
  const clean  = input.toLowerCase().replace(/[^a-z0-9]/g,'');

  return (
    <div className="game-page">
      <PageSEO page="palindrome" />
      <div className="container" style={{maxWidth:700}}>
        <Link to="/" className="back-btn"><i className="bi bi-arrow-left"></i> All Games</Link>

        <div className="game-header">
          <span className="game-icon">🔁</span>
          <h1>Palindrome Checker</h1>
          <p>Does it read the same forwards and backwards? Find out!</p>
        </div>

        <div className="solver-card">
          <form onSubmit={handleCheck}>
            <div className="mb-3">
              <label className="fw-bold mb-1">Enter a Word or Phrase</label>
              <input
                className="big-input no-upper"
                value={input}
                onChange={e => { setInput(e.target.value); setChecked(false); }}
                placeholder="e.g. racecar"
                autoFocus
              />
              <p className="pattern-hint">Spaces and punctuation are ignored when checking</p>
            </div>
            <button type="submit" className="solve-btn" disabled={!input.trim()}>
              🔁 Check Palindrome
            </button>
          </form>
        </div>

        {/* Famous examples */}
        <div className="solver-card">
          <h6 className="fw-bold mb-2">✨ Famous Palindromes — click to try!</h6>
          <div className="d-flex flex-wrap gap-2">
            {FAMOUS.map(f => (
              <button
                key={f.text}
                type="button"
                className="btn btn-sm fw-bold"
                style={{borderRadius:'50px',background:'var(--border)',border:'none',
                        fontFamily:'Nunito,sans-serif',padding:'0.3rem 0.8rem'}}
                onClick={() => { setInput(f.text); setChecked(false); }}
                title={f.label}
              >{f.text}</button>
            ))}
          </div>
        </div>

        {checked && input.trim() && (
          <div className="solver-card text-center">
            <div className={`palindrome-display ${result ? 'yes' : 'no'} mb-3`}>
              {input}
            </div>

            {result ? (
              <>
                <div style={{fontSize:'3rem'}}>🎉</div>
                <h4 className="fw-bold" style={{color:'#065f46'}}>Yes! It's a Palindrome!</h4>
                <p className="text-muted fw-bold">Reads the same forwards and backwards!</p>
              </>
            ) : (
              <>
                <div style={{fontSize:'3rem'}}>❌</div>
                <h4 className="fw-bold" style={{color:'#991b1b'}}>Not a Palindrome</h4>
                <p className="text-muted fw-bold">The word reads differently in reverse.</p>
              </>
            )}

            <div className="mt-3 p-3 rounded-3" style={{background:'#f8fafc', border:'1px solid var(--border)'}}>
              <div className="d-flex justify-content-center gap-4 flex-wrap">
                <div>
                  <small className="text-muted fw-bold d-block">Forward</small>
                  <strong style={{fontSize:'1.2rem', letterSpacing:3, fontFamily:'Fredoka One,cursive', color:'var(--primary)'}}>
                    {clean.toUpperCase()}
                  </strong>
                </div>
                <div style={{display:'flex',alignItems:'center',fontSize:'1.5rem'}}>⟺</div>
                <div>
                  <small className="text-muted fw-bold d-block">Backward</small>
                  <strong style={{fontSize:'1.2rem', letterSpacing:3, fontFamily:'Fredoka One,cursive', color: result ? 'var(--success)' : 'var(--danger)'}}>
                    {clean.split('').reverse().join('').toUpperCase()}
                  </strong>
                </div>
              </div>
            </div>
          </div>
        )}
      <SeoContent game="palindrome" />
      </div>
    </div>
  );
}
